import { observable, computed, action } from 'mobx';

import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Summary from './Summary';
import { post } from '../../../services/request';

import RoundEditStore from 'containers/Sale/RoundSection/stores/RoundEditStore';

export default class Store {
  @observable offers;

  @observable eligibleOffers;

  @observable acceptedOffers = [];

  @computed get rejectedOffers() {
    return this.offers
      .filter((item) => !this.acceptedOffers.some((i) => item.buyerId === i))
      .map((i) => i.buyerId);
  }

  @computed get acceptedOfferDetails() {
    var lookup = this.offers.reduce((acc, i) => {
      acc[i.buyerId] = i;
      return acc;
    }, {});
    return this.acceptedOffers.map((o) => lookup[o]);
  }

  @computed get rejectedOfferDetails() {
    var lookup = this.offers.reduce((acc, i) => {
      acc[i.buyerId] = i;
      return acc;
    }, {});
    return this.rejectedOffers.map((o) => lookup[o]);
  }

  @observable buyerMessage = '';

  roundEditStore = null;

  // @observable roundData = {
  //   roundType: 'counteroffer_bidding',
  //   durationType: 'fixed',
  //   startingPrice: '',
  //   estimate: '',
  //   redButtonPrice: '',
  //   endsAt: '',
  //   offerValidityUntil: '',
  //   durationInDays: defaultDurationInDays,
  //   offerValidityInDays:
  //     defaultDurationInDays + defaultOfferValidityExtensionInDays,
  // };

  steps = [
    {
      key: 'offers',
      title: 'Choose offers for next round',
      implementation: Step1,
    },
    {
      key: 'round',
      title: 'Next round details',
      implementation: Step2,
    },
    {
      key: 'message',
      title: 'Message to buyers',
      implementation: Step3,
    },
  ];

  summaryClass = Summary;

  constructor(management) {
    this.offers = management.source.offers.viewModel.offers.map((item) => {
      return {
        item,
        buyerId: item.buyerId,
        name: `${item.buyer.buyer_lastName}, ${item.buyer.buyer_firstName}`,
        submittedValue: item.submittedValue,
        validity: item.data.offer_validity,
        status: item.status,
      };
    });

    this.eligibleOffers = this.offers.filter(
      (item) => item.status !== 'block' && item.status !== 'rejected'
    );

    const { definition: round } = management.source.round;
    this.roundEditStore = new RoundEditStore(
      round,
      management.source.saleEdit.root.saleConfig
    );
    this.roundEditStore.round.type = 'counteroffer_bidding';
  }

  handleBuyerMessageChange = action((value) => {
    this.buyerMessage = value;
  });

  @action async submit(saleId, token) {
    var lookup = this.offers.reduce((acc, i) => {
      acc[i.buyerId] = i;
      return acc;
    }, {});

    const round = this.roundEditStore.saveableRound;

    var accepted = this.acceptedOffers
      .map((o) => lookup[o])
      .filter((o) => o.status === 'confirmed' || o.status === 'accepted')
      .map((o) => o.buyerId);

    await post(
      `/api/v1/wizard/${saleId}/counteroffer`,
      {
        round: {
          ...round,
          message: this.buyerMessage,
        },
        acceptOffers: accepted,
        rejectOffers: this.rejectedOffers,
      },
      token
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/Counteroffer/index.js